import { Colors } from '../colors/colors';

export const addMailConditionalStyles = (data) =>
	(!data?._mails?.length && {
		color: Colors.darkGray2,
		cursor: 'default',
	}) ||
	{};
